const LinearCalendarIcon = ({ className, stroke }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.66667 1.6665V4.1665M13.3333 1.6665V4.1665M2.91667 7.57484H17.0833M17.5 7.08317V14.1665C17.5 16.6665 16.25 18.3332 13.3333 18.3332H6.66667C3.75 18.3332 2.5 16.6665 2.5 14.1665V7.08317C2.5 4.58317 3.75 2.9165 6.66667 2.9165H13.3333C16.25 2.9165 17.5 4.58317 17.5 7.08317Z"
        stroke={stroke || "#232233"}
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0791 11.4163H13.0866M13.0791 13.9163H13.0866M9.99579 11.4163H10.0041M9.99579 13.9163H10.0041M6.91162 11.4163H6.91995M6.91162 13.9163H6.91995"
        stroke={stroke || "#232233"}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LinearCalendarIcon;
